import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/product/related_products_loader";

export default baustein.register("related-products-loader", {
    template,

    defaultOptions: {
        isOverlay: false,
        isInstock: false,
        isAffiliate: false,
        slug: null,
    },

    getInitialRenderContext() {
        return {
            related_products_loader: {
                is_loading: true,
                product_slug: null,
                related_products: null,
                is_overlay: false,
            },
        };
    },

    onInsert() {
        if (this.el.querySelector(".related-products-area")) {
            return;
        }

        const { isOverlay, isInstock, isAffiliate, slug } = this.options;

        rothko
            .fetch("modules/product/related_products_loader", {
                isOverlay,
                isInstock,
                isAffiliate,
                slug,
            })
            .then((data) => {
                this.setRenderContext({
                    related_products_loader: data,
                });
            });
    },
});
